import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { deleteUserWatcher, createUserWatcher } from '../../state/actions';
import { StateType } from '../../../state/state.types';
import { WatcherEntitityId } from '../../watchers.types';

const mapState = (
  { userWatchers }: StateType,
  { uniqueId }: { uniqueId: string },
) => ({
  isWatched: userWatchers.uniquesIds.includes(uniqueId),
});

const mapDispatch = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  async createUserEntityWatcher({
    query,
    uniqueId,
    source,
    entityIdParams,
  }: {
    query: string;
    uniqueId: string;
    source: string;
    entityIdParams: WatcherEntitityId;
  }) {
    await dispatch(
      createUserWatcher({ query, uniqueId, entityIdParams, source }),
    );
  },
  async deleteUserEntityWatcher({
    uniqueId,
    source,
  }: {
    uniqueId: string;
    source: string;
  }) {
    await dispatch(deleteUserWatcher({ uniqueId, source }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
